import React, { FC, Fragment, useState, Suspense, useEffect } from 'react';
import { Box, Button, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import OrderReview from './order-review/order-review.component';
import Invoices from './invoices/invoices.component';
import InvoiceBatches from './invoice-batches/invoice-batches.component';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { getInvoicesTemplate, getInvoiceNotesTemplate } from 'apollo/templates/invoices';
import { useNavigate, useParams } from 'react-router-dom';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DebitCreditNotes from './debit-credit-notes/debit-credit-notes.component';

const InvoicingForTechnician: FC = () => {
    const { t: translate } = useTranslation(['orders', 'invoices']);
    const { tab } = useParams<{ tab: string }>();
    const [tabState, setTabState] = useState(tab || 'invoices');
    const navigate = useNavigate();

    const handleTabChange = (_: unknown, newTabState: string) => {
        if (tabState !== newTabState) {
            navigate(`/invoices/${newTabState}`);
            setTabState(newTabState);
        }
    };

    useEffect(() => {
        handleTabChange(undefined, tab || 'invoices');
    }, [tab]);

    return (
        <Fragment>
            <TabContext value={tabState}>
                <Box mb={2} display="flex" alignItems="center" flexWrap="wrap">
                    <Box flex="1 0 auto">
                        <TabList onChange={handleTabChange} indicatorColor="primary" textColor="primary">
                            <Tab label={translate('orders:INVOICES')} value="invoices" />
                            <Tab label={translate('orders:ORDER_REVIEW')} value="order-review" />
                            <Tab label={translate('invoices:DEBIT_CREDIT_NOTES')} value="debit-credit-notes" />
                            <Tab label={translate('invoices:INVOICE_BATCHES')} value="invoice-batches" />
                            {/*
                        TODO: Enable once delayed invoices feature is completed
                        <Tab label={translate('orders:DELAYED_INVOICES')} value="delayed-invoices" />
                        */}
                        </TabList>
                    </Box>
                    <Box flex="0 0 auto">
                        <Button
                            variant="contained"
                            onClick={() => navigate('/invoices/create')}
                            startIcon={<InsertDriveFileIcon />}
                            size="medium"
                        >
                            {translate('CREATE_INVOICE')}
                        </Button>
                    </Box>
                </Box>
                <TabPanel style={{ padding: 0 }} value="invoices">
                    <Suspense fallback={null}>
                        <Invoices queryName="invoices" queryTemplate={getInvoicesTemplate} />
                    </Suspense>
                </TabPanel>
                <TabPanel style={{ padding: 0 }} value="order-review">
                    <Suspense fallback={null}>
                        <OrderReview />
                    </Suspense>
                </TabPanel>
                <TabPanel style={{ padding: 0 }} value="debit-credit-notes">
                    <Suspense fallback={null}>
                        <DebitCreditNotes queryName="invoiceNotes" queryTemplate={getInvoiceNotesTemplate} />
                    </Suspense>
                </TabPanel>
                <TabPanel style={{ padding: 0 }} value="invoice-batches">
                    <Suspense fallback={null}>
                        <InvoiceBatches />
                    </Suspense>
                </TabPanel>
                {/* <TabPanel style={{ padding: 0 }} value="delayed-invoices">
                    <Suspense fallback={null}>
                        <Invoices queryName="delayedInvoices" queryTemplate={getDelayedInvoicesTemplate} />
                    </Suspense>
                </TabPanel> */}
            </TabContext>
        </Fragment>
    );
};

export default InvoicingForTechnician;
